import { useQuery as u } from "@tanstack/vue-query";
import { computed as m, toValue as t } from "vue";
const a = ["rotatorCampaign"], s = {
  all: a,
  byRule: (o) => [...a, "rule", o]
}, y = (o, r, e) => {
  const n = m(() => s.byRule(t(r)));
  return u({
    ...e,
    queryKey: n,
    queryFn: async () => o.rotatorCampaign.findAll({ ruleId: t(r) })
  });
};
export {
  s as rotatorCampaignKeys,
  y as useRotatorCampaigns
};
//# sourceMappingURL=queries.js.map
